import React, { useState } from "react"
import { colores } from "./general"
import PopUpIncidente from "./PopUpIncidente";

export default function IncidentesPlaneados({ incidentes, usuario }) {
    let color = colores["prioridad"]

    const [incidente, setIncidente] = useState(null)
    const [top, setTop] = useState(0)
    const [left, setLeft] = useState(0)

    function drag(e, i, ind) {
        let data = { obj: "incidente", i: i, ind: ind };
        e.dataTransfer.setData("text", JSON.stringify(data));
        e.target.cursor = "move";
    }

    function popUpIncidente(e, i) {
        let maxX = document.getElementById("PIplanIncidentes").getBoundingClientRect().width
        let maxY = document.getElementById("PIplanIncidentes").getBoundingClientRect().height

        setIncidente(i)
        setLeft((e.target.getClientRects()[0].left > maxX * .75) ? maxX * 0.75 : e.target.getClientRects()[0].left)
        setTop((e.target.getClientRects()[0].top > maxY * .9) ? maxY * 0.9 : e.target.getClientRects()[0].top)
    }

    return (
        <div style={Sgrupo} >
            {incidentes.map((i, ind) =>
                <div style={{
                    ...Sincidente,
                    background: `${(i.responsable !== i.usuarioActual && i.responsable === usuario) ? "grey" : color[i.prioridad]}`,
                    border: `${(i.responsable !== i.usuarioActual && i.responsable !== usuario) ? "3px solid blue" : "1px solid #424242"}`
                }}
                    key={i.id} draggable={i.responsable === i.usuarioActual || i.responsable !== usuario} onDragStart={(e) => drag(e, i, ind)}
                    onClick={(e) => popUpIncidente(e, i)}>
                    <div><b>{i.id}</b></div>
                    <div>{i.categoria}</div>
                    <div>{i.horas + " horas"}</div>
                </div>
            )}
            {incidente && <PopUpIncidente incidente={incidente} top={top} left={left} set={setIncidente} />}
        </div >
    )
}

const Sgrupo = {
    display: "grid",
    gridTemplateColumns: "33% 33% 33%",
}
const Sincidente = {
    display: "flex",
    flexDirection: "column",
    fontSize: "1.4vh",
    textAlign: "center",
    border: "1px solid white",
    borderRadius: "5px",
    margin: "5px",
    width: "85%",
    overflow: "hidden",
    cursor: "pointer"
};
